<template>
  <div id="buddy-customisation-window">
    <button v-if="customisationType === 'accessory'" class="btn close-button" v-on:click="closeClicked">
    </button>
    <div class="customisation-window-wrapper">
      <div v-if="customisationType === 'buddy'" class="side-column">
        <CustomisationTabButton :key="bodyPartType.id" v-for="bodyPartType in allBodyParts"
                                :bodyPartType="bodyPartType.id" v-on:clicked="tabClicked"></CustomisationTabButton>
        <div class="customisation-tab-button colorTabButton" v-on:click="colorsTabClicked">
          <button class="btn">
            <span class="icon colors"></span>
          </button>
        </div>
      </div>

      <div v-if="customisationType === 'accessory'" class="side-column">
        <CustomisationTabButton :key="accessoryType" v-for="accessoryType in accessoryTabOrder"
                                :accessoryType="accessoryType" v-on:clicked="tabClicked"
                                :showNotification="tabsWithNotifications.find(t => t === accessoryType) !== undefined"></CustomisationTabButton>
        <div class="customisation-tab-button colorTabButton" v-on:click="colorsTabClicked">
          <button class="btn">
            <span class="icon colors"></span>
          </button>
        </div>
      </div>

      <div class="content">
        <div class="tab-title">
          <p>{{ getTabTitles[currentTab] }}</p>
        </div>

        <div class="items" v-if="customisationType === 'buddy'">
          <div class="parts-tab" :class="'parts-tab-'+bodyParts.id" :key="bodyParts.id"
               v-for="bodyParts in allBodyParts"
               :bodyParts="bodyParts.parts">
            <div class="parts-list">
              <CustomisationItemButton :key="part.id" v-for="part in bodyParts.parts" :part="part" :kind="'body'"
                                       :buddyData="buddy"
                                       v-on:clicked="itemClicked"></CustomisationItemButton>
            </div>
          </div>

          <div class="parts-tab parts-tab-colors">
            <div class="parts-list">
              <div class="color-tab-button-row">
                <button class="btn color-tab-button color-tab-button-0 selected" v-on:click="colorTabClicked(0)">
                  <p>1</p>
                  <div class="example bb_colour_01" :style="{backgroundColor: getBackgroundColor(0)}">
                  </div>
                </button>

                <button class="btn color-tab-button color-tab-button-1" v-on:click="colorTabClicked(1)">
                  <p>2</p>
                  <div class="example" :style="{backgroundColor: getBackgroundColor(1)}"></div>
                </button>

                <button class="btn color-tab-button color-tab-button-2" v-on:click="colorTabClicked(2)">
                  <p>3</p>
                  <div class="example" :style="{backgroundColor: getBackgroundColor(2)}"></div>
                </button>
              </div>
              <div class="color-selection">
                <CustomisationColorButton :key="color" v-for="color in allBuddyColors" :color="color"
                                          v-on:clicked="colorClicked"></CustomisationColorButton>
              </div>
            </div>
          </div>

        </div>

        <div class="items" v-if="customisationType === 'accessory'">
          <div class="parts-tab" :class="'parts-tab-'+accessories.id" :key="accessories.id"
               v-for="accessories in allAccessories" :accessories="accessories.parts" :category="accessories.id">
            <div class="parts-list">

              <CustomisationItemButton :key="'noAccessory'" :kind="'accessory'"
                                       :part="{id: 'remove', category:accessories.id}" :buddyData="buddy"
                                       v-on:clicked="noItemClicked({type: accessories.id, id:'remove'})"
                                       :class="accessories?.parts?.length<=0?'small': ''"></CustomisationItemButton>

              <CustomisationItemButton :key="part.id" v-for="part in accessories.parts" :part="part" :buddyData="buddy"
                                       :kind="'accessory'" v-on:clicked="itemClicked"></CustomisationItemButton>
            </div>
          </div>

          <div class="parts-tab parts-tab-colors">
            <div class="parts-list">
              <div class="color-tab-button-row">
                <button class="btn color-tab-button color-tab-button-0 selected" v-on:click="colorTabClicked(0)">
                  <p>1</p>
                  <div class="example bb_colour_01" :style="{backgroundColor: getBackgroundColor(0)}">
                  </div>
                </button>

                <button class="btn color-tab-button color-tab-button-1" v-on:click="colorTabClicked(1)">
                  <p>2</p>
                  <div class="example" :style="{backgroundColor: getBackgroundColor(1)}"></div>
                </button>

                <button class="btn color-tab-button color-tab-button-2" v-on:click="colorTabClicked(2)">
                  <p>3</p>
                  <div class="example" :style="{backgroundColor: getBackgroundColor(2)}"></div>
                </button>
              </div>
              <div class="color-selection">
                <CustomisationColorButton :key="color" v-for="color in allBuddyColors" :color="color"
                                          v-on:clicked="colorClicked"></CustomisationColorButton>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="confirm-button">
        <button class="btn" v-on:click="confirmClicked"><span v-if="!savingBuddy">{{ confirmButtonText }}</span> <span
            v-if="savingBuddy" class="load-icon">Bezig met opslaan...</span></button>
      </div>

    </div>


  </div>
</template>

<script>
import $ from 'jquery';
import {BPID} from "@/enums/BodyPartIdEnum.js";
import {AID} from "@/enums/AccessoryIdEnum";
import {BodyPartNames} from "@/mixins/BodyPartNames";
import {AccessoryNames} from "@/mixins/AccessoryNames";
import {AccessoryTranslation} from "@/mixins/AccessoryTranslation";
import {BuddyApi} from "sandpiper_api";
import log from "@/utils/logger";


import CustomisationTabButton from "@/components/StudentPlatform/Customisation/Buddy/CustomisationTabButton";
import CustomisationItemButton from "@/components/StudentPlatform/Customisation/Buddy/CustomisationItemButton";
import CustomisationColorButton from "@/components/StudentPlatform/Customisation/Buddy/CustomisationColorButton";
import BodyPartLibrary from "@/mixins/BodyPartLibrary";
import AccessoryLibrary from "@/mixins/AccessoryLibrary";


export default {
  name: "CustomisationWindow",
  components: {CustomisationTabButton, CustomisationItemButton, CustomisationColorButton},
  props: {
    selectedColors: Object,
    buddy: Object,
    savingBuddy: Boolean,
    customisationType: String,
    showCustomisationWindow: Boolean,
    triggerFetch: Boolean,
    levelUpReward: Object,
  },
  inject: ["doApiRequest"],
  data() {
    return {
      isMounted: false,
      bodyPartTypes: BPID,
      allBodyParts: ['wow'],
      allAccessories: ['wow'],
      allBuddyColors: ['rgb(42,42,42)', 'rgb(88,88,88)', 'rgb(168,168,168)', 'rgb(255,255,255)', 'rgb(228,174,138)', 'rgb(255,208,155)', 'rgb(255,189,167)', 'rgb(255,155,164)', 'rgb(225,87,186)', 'rgb(223,31,119)', 'rgb(190,101,144)', 'rgb(144,101,191)', 'rgb(99,24,190)', 'rgb(69,18,128)', 'rgb(17,49,111)', 'rgb(17,90,128)', 'rgb(0,152,235)', 'rgb(124,209,255)', 'rgb(66,86,27)', 'rgb(101,141,28)', 'rgb(252,230,28)', 'rgb(248,204,101)', 'rgb(248,170,0)', 'rgb(240,133,0)', 'rgb(225,43,29)', 'rgb(147,30,21)', 'rgb(129,84,55)', 'rgb(83,49,0)',],
      buddyTabTitles: {
        [BPID.EYES]: 'Ogen',
        [BPID.MOUTH]: 'Mond',
        [BPID.NOSE]: 'Neus',
        [BPID.EAR_LEFT]: 'Oren',
        [BPID.ANTENNA]: 'Antenne',
        [BPID.WHISKERS]: 'Snorharen',
        'colors': 'Kleuren'
      },
      buddyTabOrders: {
        1: [
          BPID.EYES,
          BPID.MOUTH,
          BPID.NOSE,
          BPID.EAR_LEFT,
          BPID.ANTENNA,
          'colors',
        ],
        2: [
          BPID.EYES,
          BPID.MOUTH,
          BPID.NOSE,
          BPID.EAR_LEFT,
          BPID.ANTENNA,
          BPID.WHISKERS,
          'colors',
        ],
        3: [
          BPID.EYES,
          BPID.MOUTH,
          BPID.NOSE,
          BPID.EAR_LEFT,
          BPID.ANTENNA,
          'colors',
        ],

      },
      accessoryTabOrder: [
        AID.HAT,
        AID.SHIRT,
        AID.PANTS,
        AID.SHOE_LEFT,
        AID.HAND,
      ],
      accessoriesTabTitles: {
        [AID.SHIRT]: 'Bovenlichaam',
        [AID.PANTS]: 'Broek',
        [AID.HAT]: 'Hoed',
        [AID.HAND]: 'Accessoire',
        [AID.SHOE_LEFT]: 'Schoenen',
        'colors': 'Gadget Kleuren'
      },
      currentTab: '',
      currentColorTab: 0,
      serverBodyParts: [],
      serverAccessories: [],
      tabsWithNotifications: [],
    }
  },
  computed: {
    getTabTitles() {
      if (this.customisationType === 'buddy') {
        return BodyPartNames;
      } else {
        return AccessoryNames;
      }
    },
    currentTabIndex() {
      if (this.customisationType === 'buddy') {
        let tab = this.getBuddyTabOrderForGrade().find(t => t === this.currentTab);
        if (tab !== undefined) {
          return this.getBuddyTabOrderForGrade().indexOf(tab);
        } else {
          return null;
        }
      } else {
        return null;
      }
    },

    nextTab() {
      if (this.customisationType === 'buddy') {
        return this.getBuddyTabOrderForGrade()[this.currentTabIndex + 1];
      } else {
        return null;
      }
    },

    confirmButtonText() {
      if (this.customisationType === 'buddy') {
        if (this.currentTabIndex >= this.getBuddyTabOrderForGrade().length - 1) {
          return 'Buddy opslaan';
        } else {
          return 'Volgende stap';
        }
      } else {
        return 'Wijzigingen opslaan';
      }
    },

  },
  watch: {
    buddy: {
      handler() {
        if (this.buddy.id !== null && this.buddy.id !== undefined) {
          this.setUnlockedEquipment();
          this.setAccessoryColors();
        }
      },
      deep: true,
    },
    triggerFetch: {
      handler() {
        if (this.triggerFetch && this.buddy.id !== null && this.buddy.id !== undefined) {
          this.setUnlockedEquipment();
        }
      },
    },
    levelUpReward: {
      handler() {
        if (this.levelUpReward) {
          this.setupNewItemNotification();
        }
      },
    },
    showCustomisationWindow: {
      handler() {
        if (this.showCustomisationWindow) {
          this.$nextTick(function () {
            this.$el.querySelectorAll('.parts-tab').forEach(partsTab => {
              $(partsTab).hide();
            });
            $('.items:first-child').show();

            if (this.tabsWithNotifications.length > 0) {
              this.tabClicked(this.tabsWithNotifications[0], true);
            } else {
              this.tabClicked('hand');
            }

          });
        }
      },
    }
  },

  mixins: [BodyPartLibrary, AccessoryLibrary],
  methods: {
    closeButton() {
      this.visible = false;
    },
    tabClicked(tab, fakeClick) {
      console.log("tab clicked " + tab);
      this.$el.querySelectorAll('.parts-tab').forEach(partsTab => {
        $(partsTab).hide();
      });
      $('.parts-tab-' + tab).show();
      this.currentTab = tab;

      this.$el.querySelectorAll('.side-column>.customisation-tab-button').forEach(tabButton => {
        $(tabButton).removeClass('selected');
      });
      $('.customisation-tab-button.' + tab).addClass('selected');

      //remove notification
      if (!fakeClick && this.tabsWithNotifications.includes(tab)) {
        let i = this.tabsWithNotifications.indexOf(tab);
        this.tabsWithNotifications.splice(i, 1);
      }
      console.log("notifications removed");
    },
    colorsTabClicked() {
      this.$el.querySelectorAll('.parts-tab').forEach(partsTab => {
        $(partsTab).hide();
      });
      $('.parts-tab-colors').show();
      this.currentTab = "colors";

      this.$el.querySelectorAll('.side-column>.customisation-tab-button').forEach(tabButton => {
        $(tabButton).removeClass('selected');
      });
      $('.customisation-tab-button.colorTabButton').addClass('selected');

    },

    noItemClicked(data) {
      this.$emit("removeItemClicked", data.type);
      //$('.customisation-option.' + data.id).addClass('selected');
      this.$el.querySelectorAll('.parts-tab-' + data.type + '>.parts-list>.customisation-option').forEach(item => {

        $(item).removeClass('selected');
      });
      $('.customisation-option.' + 'remove').addClass('selected');

    },

    itemClicked(data) {
      data.id = this.getServerIdForItem(data.name, data.kind);
      this.$emit("itemClicked", data);

      this.$el.querySelectorAll('.parts-tab-' + data.type + '>.parts-list>.customisation-option').forEach(partsTab => {

        $(partsTab).removeClass('selected');
      });
      console.log(data)
      $('.customisation-option.' + data.name).addClass('selected');
    },

    getServerIdForItem(id, kind) {
      if (kind === "body") {
        return this.serverBodyParts.find(item => item.name === id).id;
      } else {
        return this.serverAccessories.find(item => item.name === id).id;

      }
    },
    colorClicked(data) {
      console.log(data);
      this.$emit("colorClicked", {color: data, id: this.currentColorTab, kind: this.customisationType});
    },
    colorTabClicked(id) {
      this.currentColorTab = id;

      this.$el.querySelectorAll('.color-tab-button').forEach(tabButton => {
        $(tabButton).removeClass('selected');
      });
      $('.color-tab-button-' + id).addClass('selected');
    },
    closeClicked() {
      this.$emit("closeClicked");
    },
    confirmClicked() {
      if (this.customisationType === 'buddy') {
        let buddyTabOrder = this.getBuddyTabOrderForGrade();
        if (this.currentTab === buddyTabOrder[buddyTabOrder.length - 1]) {
          this.$emit("confirmClicked");
        } else if (this.currentTab === buddyTabOrder[buddyTabOrder.length - 2]) {
          this.colorsTabClicked();
        } else {
          this.tabClicked(this.nextTab);
        }
      } else {
        this.$emit("confirmClicked");
      }
    },

    setupNewItemNotification() {
      console.log("setting up new item notifications")
      this.tabsWithNotifications = [];
      console.log(this.levelUpReward);
      if (this.levelUpReward.accessoryRewards && this.levelUpReward.accessoryRewards.length > 0) {
        this.levelUpReward.accessoryRewards.forEach(acc => {
          let accessoryType = Object.keys(AccessoryTranslation).find(key => AccessoryTranslation[key] === acc.type);
          this.tabClicked(accessoryType);
          this.tabsWithNotifications.push(accessoryType);
          console.log(accessoryType)
        });
      }

      console.log("new item nitifications set up")
    },


    getBackgroundColor(id) {
      let result = '';
      if (this.customisationType === 'buddy') {
        switch (id) {
          case 0:
            result = this.selectedColors.buddy_primary + '!important';
            break;
          case 1:
            result = this.selectedColors.buddy_secondary + '!important';
            break;
          case 2:
            result = this.selectedColors.buddy_tertiary + '!important';
            break;
        }
      }

      if (this.customisationType === 'accessory') {
        switch (id) {
          case 0:
            result = this.selectedColors.accessory_primary + '!important';
            break;
          case 1:
            result = this.selectedColors.accessory_secondary + '!important';
            break;
          case 2:
            result = this.selectedColors.accessory_tertiary + '!important';
            break;
        }
      }

      return result;
    },

    async fetchBodyParts() {
      try {
        this.fetchingBodyParts = true;
        const response = await this.doApiRequest(() => new BuddyApi().getBuddyBodyParts());

        log.info("Fetch body parts response: %o", response);
        this.serverBodyParts = response;

      } catch (e) {
        this.serverBodyParts = null;
        // TODO - handle exception,
      } finally {
        this.fetchingBodyParts = false;
      }
    },

    async fetchAccessories() {
      try {
        this.fetchingAccessories = true;
        const response = await this.doApiRequest(() => new BuddyApi().getUnlockedEquipmentForBuddy(this.buddy.id));
        this.serverAccessories = response;

      } catch (e) {
        this.serverAccessories = null;
        // TODO - handle exception,
      } finally {
        this.fetchingAccessories = false;
      }
    },

    setInitialBuddy() {

      this.itemClicked({name: 'antenna-01', type: 'antenna', kind: "body"});
      this.itemClicked({name: 'ears-01', type: 'ear_left', kind: "body"});
      this.itemClicked({name: 'eyes-01', type: 'eyes', kind: "body"});
      this.itemClicked({name: 'whiskers-01', type: 'whiskers', kind: "body"});
      this.itemClicked({name: 'mouth-01', type: 'mouth', kind: "body"});
      this.itemClicked({name: 'nose-01', type: 'nose', kind: "body"});

      this.currentColorTab = 0;
      this.colorClicked('rgb(205,130,30)');
      this.currentColorTab = 1;
      this.colorClicked('rgb(140,75,165)');
      this.currentColorTab = 2;
      this.colorClicked('rgb(255,195,150)');
      this.currentColorTab = 0;

    },

    //dirty
    setUnlockedEquipment() {
      console.log("setting unlocked equipments");
      let that = this;
      that.$nextTick(function () {
        if (this.customisationType === 'accessory') {
          this.fetchAccessories().then(() => {
            AccessoryLibrary.getAllCustomisableAccessories(that.buddy.buddyConfig.grade).then(function (result) {

              console.log(result);
              let filteredItems = {};

              for (const [key, value] of Object.entries(result)) {
                filteredItems[key] = {id: value.id, name: value.name, parts: []};

                value.parts.forEach((item) => {
                  if (that.serverAccessories.find(acc => acc.name === item.id)) {
                    filteredItems[key].parts.push(item);
                  }
                });
              }

              that.allAccessories = filteredItems;
            });
          });
        }

      })
    },

    setAccessoryColors() {

    },

    getBuddyTabOrderForGrade() {

      return this.buddyTabOrders[this.getRealGrade()]
    },
    getRealGrade() {
      return Math.ceil(this.buddy.buddyConfig.grade / 2);
    }
  },

  mounted() {
    let that = this;

    if (this.customisationType === 'buddy') {
      this.fetchBodyParts().then(() => {

        that.setInitialBuddy();

        BodyPartLibrary.getAllCustomisableBodyParts(that.buddy.buddyConfig.grade).then(function (result) {

          that.allBodyParts = result;

          //lower grade buddies don't have all body parts
          let grade = that.getRealGrade();
          console.log("[CW] grade is " + grade);
          if (grade === 1 || grade === 3) {
            that.allBodyParts = {
              'eyes': that.allBodyParts.eyes,
              'mouth': that.allBodyParts.mouth,
              'nose': that.allBodyParts.nose,
              'ear_left': that.allBodyParts.ear_left,
              'antenna': that.allBodyParts.antenna,
            };
          }

          that.$nextTick(function () {
            //hide all generated views
            that.$el.querySelectorAll('.parts-tab').forEach(partsTab => {
              $(partsTab).hide();
            });
            //then show the first one
            $('.items:first-child').show();
            this.tabClicked('eyes');
          });
        });
      });
    }

  },

  created() {
    if (this.buddy.id !== null && this.buddy.id !== undefined) {
      this.setUnlockedEquipment();
    }
  }
}


</script>

<style lang="scss" scoped>
#buddy-customisation-window {
  width: min(47vw, calc(100vh * 1.77777 / 2));
  margin-left: 50%;
  height: 90%;
  padding: 0px 2%;
  background-image: url("~@/assets/image/customise/bb_frame.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  will-change: transform;
  display: flex;
}

.close-button {
  width: 50px;
  height: 50px;
  position: absolute;
  right: -1%;
  top: -1%;
  background-image: url("~@/assets/image/button/bb_button_close.svg");

}

.customisation-window-wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
  justify-content: space-between;
  padding: 8% 0;

}

.side-column {
  width: 15%;
  margin-right: 2%;
  flex-direction: column;
  align-items: stretch;
  display: flex;
  justify-content: space-between;
}

.content {
  width: 87%;
  display: flex;
  flex-direction: column;

}

.tab-title-arrow-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 0%;
}

.tab-title {
  width: 94%;
  height: 10%;
  margin: 2% 0 2% 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-image: url("~@/assets/image/customise/bb_frame_title.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-left: 10%;

  p {
    font-size: 1.5rem;
    text-transform: uppercase;
    font-weight: bold;
    color: white;
    margin-bottom: 0px;
    margin-top: 0px;
  }

}

.items {
  height: 100%;
}

.parts-tab {
  width: 100%;
  height: 100%;

  .parts-list {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    height: 100%;
    //overflow: overlay;
    overflow-y: scroll;
  }
}

.parts-tab-colors {
  .parts-list {
    overflow-y: auto;
    padding-bottom: 20px;

    .color-selection {
      padding-right: 67px;
    }
  }
}

::-webkit-scrollbar,
::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
  width: 54px;
  border: none;
  background: transparent;
}

::-webkit-scrollbar-button,
::-webkit-scrollbar-track-piece,
::-webkit-scrollbar-corner,
::-webkit-resizer {
  display: none;
}

::-webkit-scrollbar-thumb {
  background-image: url("~@/assets/image/platform/bb_scroll.svg");
  background-repeat: no-repeat;
  height: 54px;
}

::-webkit-scrollbar-track {
  background-image: url("~@/assets/image/platform/customise/scrollbar-track.png");
  background-repeat: repeat-y;
  background-size: contain;
  margin-left: 54px;
}

.parts-tab-colors {
  width: 94%;
  height: 100%;
  margin-left: 3%;

  .parts-list {
    display: block;
  }
}

.confirm-button {
  width: 60%;
  margin-left: 18%;
  display: flex;
  justify-content: center;
  height: 11%;
  position: absolute;
  bottom: -4%;

  .btn {
    width: 100%;
    height: 100%;

    background-image: url("~@/assets/image/button/bb_button.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    color: white;
    font-weight: bold;
  }
}


//just for colors tab button, kindof the wrong place for that
.customisation-tab-button {
  display: flex;
  flex: 1 1;
  height: 68px;

  .btn {
    min-width: 50px;
    width: 100%;
    height: 100%;
    background-image: url("~@/assets/image/customise/bb_category.svg");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;

    .icon {
      width: 100%;
      height: 100%;
      display: block;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }
}


.icon.colors {
  background-image: url("~@/assets/image/customise/color/bb_category07_kleuren.svg");
}

.color-tab-button-row {
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: space-between;

  button {
    flex: 1 1;
    display: flex;
    align-items: center;
    padding: 2% 5%;


    p {
      color: white;
      font-weight: bold;
      font-size: 2rem;
      margin-top: 0px;
      margin-bottom: 0px;
    }

    .example {
      width: 100%;
      height: 100%;
      margin-left: 5px;
      -webkit-mask: url("~@/assets/image/customise/color/bb_color.svg") no-repeat 100% 100%;
      mask: url("~@/assets/image/customise/color/bb_color.svg") no-repeat 100% 100%;
      background-color: yellow;
    }

    &.selected {
      background-image: url("~@/assets/image/customise/color/bb_color_frame.svg");
      background-repeat: no-repeat;
      background-size: cover;

    }
  }
}

.customisation-tab-button.selected > .btn {
  background-image: url("~@/assets/image/customise/bb_category_selected.svg");

}

.color-selection {
  width: 100%;
  height: 80%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  grid-gap: 1rem;
  padding: 1rem;

  //overflow: scroll;
  //overflow: overlay;
  overflow-y: scroll;
  background-color: rgb(0, 0, 41);
}

</style>